<template>
  <v-card
    class="main__light_green pa-0 text-start"
    elevation="0">
    <span
      v-if="type"
      class=" h9-label">{{ bigFirstLetter(type == 'main' ? $t('Tenders.ContactPerson') : $t('Tenders.AdditionalContactPerson') ) }}</span>
    <v-list
      v-if="load"
      class="pt-5 px-0 main__light_green">
      <v-list-item
        v-for="(i, n) in new Array(3)"
        :key="n"
        class="main__light_green px-0 pb-5">
        <v-skeleton-loader
          ref="skeleton"
          :boilerplate="false"
          class="main__green--text"
          :tile="false"
          type="sentences"
          width="70%"/>
      </v-list-item>
    </v-list>
    <v-card-text
      v-else
      class="px-0 person-block">
      <div>
        <div class="flex flex-wrap flex-direction-column">
          <span class=" h8-text pl-4 black--text">
            {{ $t('Common.Initials') }}
          </span>
          <sSelect
            :allow-create="type == 'additional'"
            autocomplete
            class="person-name width-100"
            clearable
            data-qa="person-name"
            filterable
            :placeholder="$t('Common.Initials')"
            :readonly="!selectable"
            :value.sync="persona"
            value-key="contactId">
            <template #empty>
              <ToggleHiddenPeople
                v-if="type == 'additional' && people.some(el => el.hidden) "
                class="s-select-dropdown__wrap"
                :hide_people="hide_people"
                :toggle-hidden="toggleHidden"/>
            </template>
            <ToggleHiddenPeople
              v-if="type == 'additional' && people.some(el => el.hidden) "
              :hide_people="hide_people"
              :toggle-hidden="toggleHidden"/>
            <template
              v-for="item in items">
              <sOption
                v-if="!hide_people || !item.hidden"
                :key="`person-${item.contactId}`"
                class="person-option-item "
                :data-qa="`person-${item.contactId}`"
                :disabled="load_hide[item.contactId]"
                :label="item.name"
                :value="item">
                <div
                  class="flex-between align-center">
                  <div class="option__content">
                    <div :class="{'grey--text': item.hidden}">
                      {{ item.name }}
                    </div>
                    <div class="grey--text h8-text">
                      {{ item.phone }}
                    </div>
                    <div class="grey--text h8-text">
                      {{ item.email }}
                    </div>
                  </div>
                  <sButton
                    v-if="type == 'additional' "
                    class="hide-button pa-0"
                    :icon="item.hidden ? 'eye' : 'eye-slash'"
                    :loading="load_hide[item.contactId]"
                    small
                    type="text"
                    @click.stop="hidePerson(item)"/>
                </div>
              </sOption>
            </template>
          </sSelect>
        </div>
      </div>
      <CustomTextarea
        v-if="!editable"
        class="mt-8 person-phone"
        :label="$t('Common.PhoneNumber')"
        placeholder="+ 380 (––) ––– –– ––"
        :readonly="!editable"
        rounded
        rows="1"
        :value.sync="persona.phone"/>
      <CustomMaskedInput
        v-else
        class="mt-8 person-phone"
        debounce
        :label="$t('Common.PhoneNumber')"
        mask="\+\380 (11) 111 11 11"
        :message="phone_error"
        :model.sync="persona.phone"
        placeholder="+ 380 (––) ––– –– ––"
        placeholder_char="–"
        @input="numberRules"/>
      <TextField
        class-name=" mt-8 person-mail"
        debounce
        :error_messages="email_error"
        :label="$t('Common.MailAddress')"
        max_length="50"
        :model.sync="persona.email"
        not_clearable
        :placeholder="$t('Common.MailAddress')"
        :readonly="!editable"
        show_details
        @action="chckMail"/>
    </v-card-text>
  </v-card>
</template>
<script>
import TextField from 'components/common/inputs/TextField.vue'
import CustomTextarea from 'components/common/inputs/CustomTextarea.vue'
import CustomMaskedInput from 'components/common/inputs/CustomMaskedInput.vue'
import ToggleHiddenPeople from 'components/tenders/tender creation/ToggleHiddenPeople.vue'

import { modalMixin } from 'mixins'
import SmarttenderApi from '@/api/smarttenderApi'
const api = new SmarttenderApi()

export default {
  name: 'newContactPerson',
  mixins: [ modalMixin],
  data() {
    return {
      name: '',
      email_error: '',
      phone_error: '',
      hide_people: true,
      load_hide: {}
    }
  },
  props: {
    /**
     * доп. особа текущего компонента
     */
    person: [Object, String],
    /**
     * Доступные существующие доп. особы
     */
    people: Array,
    load: Boolean,
    /**
     * Выбранные доп. контактные сособы тенедера (если будет когда-то множество)
     */
    chosed: {
      type: Array,
      default: () => []
    },
    /**
     * Введна ли новая особа руками
     */
    editable: Boolean,
    /**
     * Похоже, не нужный параметр
     */
    selectable: {
      type: Boolean,
      default: true
    },
    /**
     * Главная контактная особа
     */
    contactPerson: Object,
    /**
     * правило валидации почты
     */
    mailRules: Function,
    /**
     * тип контактної
     */
    type: {
      type: String,
      validator: (val) => ['main', 'additional'].includes(val)
    },
  },
  computed: {
    persona: {
      get() {
        return this.person
      },
      set(value) {
        this.$emit('update:person', value)
      }
    },
    items() {
      if (!this.people?.length) {
        return []
      }

      return this.people.filter(el => {
        let current = el?.contactId == this.person?.contactId,
          additional = !this.chosed.some(item => item?.contactId == el?.contactId) || current,
          main_person = el?.contactId == this.contactPerson?.contactId/*,
          hidden = !this.hide_people || !el.hidden || current*/
        return additional && !main_person /* && hidden*/
      })
    }
  },
  methods: {
    numberRules( text) {
      if (!text) { return true }
      let error = text != '+380 (––) ––– –– ––' && text?.includes('–')
      return this.phone_error = error ? this.$t('Tenders.PhoneNumRules') : ''
    },
    chckMail(text) {
      if (!this.mailRules) { return }
      this.email_error = this.mailRules(text)
    },
    hidePerson(item) {
      if ( !item.contactId ) { return }
      this.$set( this.load_hide, item.contactId, true)
      api.changeAdditionalContactHidingStatus({
        contactId: item.contactId,
        hide: !item.hidden
      })
        .then(res => {
          if ( res ) {
            const people = this.$_.cloneDeep(this.people)
            const cloneItem = people.find(i => i.contactId === item.contactId)
            cloneItem.hidden = !cloneItem.hidden
            this.$emit('update:people', people)
          }
        })
        .finally(() => {
          this.$set( this.load_hide, item.contactId, false)
        })
    },
    toggleHidden() {
      this.hide_people = !this.hide_people
    }
  },
  watch: {
    name(val) {
      this.$emit('update:editing', !!val && this.persona?.name != val )
    },
    persona(newObject, old) {
      if ( newObject && typeof newObject != 'object') {
        this.persona = {
          name: newObject,
          email: old && !old?.contactId ? old.email : '',
          phone: old && !old?.contactId ? old.phone : ''
        }
      }
      if (!newObject) {
        this.persona =  {
          contactId: '',
          name: '',
          email: old && !old?.contactId ? old.email : '',
          phone: old && !old?.contactId ? old.phone : ''
        }
      }
      this.chckMail(this.persona?.email)
    },
  },
  components: {
    TextField,
    CustomTextarea,
    CustomMaskedInput,
    ToggleHiddenPeople
  }
}
</script>
<style lang="scss" scoped>
.person-block {
  width: 400px;
}

</style>
<style lang="scss">
.person-mail {
  .v-text-field__details {
    height: 26px;
  }
}
.person-option-item  {
  .hide-button:not(.is-loading) {
    visibility: hidden;
    transition: visibility 0s ease !important;
  }
  &:hover .hide-button {
    visibility: visible;
  }
}
</style>
